import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types/DynamicClient';
import { getAvailableWalletProvidersFromWalletAccounts } from '../utils/getAvailableWalletProvidersFromWalletAccounts';

/**
 * Disconnect and terminate each wallet provider, if available.
 */
export const disconnectAndTerminateWalletProviders = async (
  client: DynamicClient
) => {
  const core = getCore(client);

  const walletProviders = getAvailableWalletProvidersFromWalletAccounts(client);

  await Promise.all(
    walletProviders.map(async (walletProvider) => {
      if (walletProvider.terminate) {
        await walletProvider.terminate();
      }

      if (walletProvider.disconnect) {
        try {
          await walletProvider.disconnect();
        } catch (err) {
          core.logger.error(
            `Error disconnecting from wallet ${walletProvider.key}`,
            err
          );
        }
      }
    })
  );
};
